import { makeObservable, computed } from "mobx";

import {
  NotificationsStore as NotificationsStoreType,
  UserStore as UserStoreType,
} from "@voxmedia/duet-context/context/notifications-context";

import NotificationsListStore from "./NotificationsListStore";

class UnreadNotificationsStore extends NotificationsListStore {
  public constructor(
    userStore: UserStoreType,
    notificationsStore: NotificationsStoreType,
  ) {
    super(userStore, notificationsStore);
    makeObservable(this, {
      visibleNotifications: computed,
    });
  }

  public get visibleNotifications() {
    return this.notifications.filter((notification) => !notification.read);
  }
}

export default UnreadNotificationsStore;
